document.querySelectorAll('.plant-index-letters button').forEach(function (element) {
    element.addEventListener('click', function (event) {
        let otherActive = document.querySelector('.plant-index-letters button.active');
        if (otherActive) {
            otherActive.classList.remove('active');
        }
        element.classList.add('active');
    });
});
let breadcrumbs = document.querySelector('#plant-index-navigation');
document.addEventListener('click', function (event) {
    if (event.target.tagName === 'BUTTON' && event.target.hasAttribute('data-target')) {
        let element = event.target;
        let target = document.querySelector(element.getAttribute('data-target'));
        let level = element.getAttribute('data-level');
        if (!level) {
            level = 'group';
        }
        let indexFound = false;
        if (level === 'index') {
            breadcrumbs.querySelectorAll('li').forEach(function (el) {
                el.remove();
            });
        } else {
            breadcrumbs.querySelectorAll('li').forEach(function (el, key) {
                if (indexFound > 0) {
                    el.remove();
                    return;
                }
                if (el.innerText === element.innerText) {
                    indexFound = key;
                }
            });
        }
        if (indexFound === false) {
            let childItem = document.createElement("li");
            let cloned = element.cloneNode(true);
            cloned.classList.remove('active');
            childItem.append(cloned);
            breadcrumbs.append(childItem);
        }
        document.querySelectorAll('div[data-level="' + level + '"].active').forEach(function (levelElement, key, parent) {
            levelElement.classList.remove('active');
        });
        document.querySelectorAll('div[data-level="group"].active').forEach(function (levelElement, key, parent) {
            levelElement.classList.remove('active');
        });
        if (target) {
            target.classList.add('active');
            let allHidden = target.querySelectorAll('div.active').length === 0;
            if (allHidden) {
                let child = target.querySelector('[data-level="group"]:first-child');
                if (child) {
                    child.classList.add('active');
                }
            }
        }
        event.preventDefault();
    }
})